import { FileText } from 'lucide-react';
import type { NavItem } from './types';

/**
 * The «DTEs» destination (§4.12), with its two children: Emitidos (view 7, the
 * listing) and Emitir (view 9, issuing) — already landed. An item WITH children
 * expands instead of navigating (`AppShell`), so `to` on the parent node is not
 * used to navigate: only the children carry a real route.
 */
export const dtesNav: readonly NavItem[] = [
  {
    label: 'DTEs',
    to: '/dtes',
    icon: FileText,
    group: 'operation',
    minimumPhase: 'in-certification',
    children: [
      { label: 'Emitidos', to: '/dtes' },
      { label: 'Emitir', to: '/dtes/new' },
    ],
  },
];
